var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowToast)?_c('div',{staticClass:"toast"},[_c('div',{staticClass:"toast_box"},[_c('div',{staticClass:"toast_box_item"},[_vm._m(0),_c('div',{staticClass:"toast_box_remark"},[_vm._v(_vm._s(_vm.remark))])])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast_box_img"},[_c('img',{attrs:{"src":require("../../../../assets/integrity/icon_ts_gx@3x.png"),"alt":""}})])
}]

export { render, staticRenderFns }